var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as moment from 'moment';
import * as React from 'react';
import { PhotoCaptureAllowedMimeTypeConstant, PhotoCaptureConstants } from '../../constants';
import { IntelligentPhotoCaptureViewType } from '../../enums';
import { addGpsToImage, getScreenTitleText } from '../../utilities';
import { IntelligentGenericWebcamComponent } from './IntelligentGenericWebcamComponent';
import { IntelligentPBEContainerComponent } from './IntelligentPBEContainerComponent';
export const IntelligentPhotoCaptureCameraView = ({ onViewChange, onSaveCapturedPhoto, questionSubType, appTheme, sequenceScreenName, disableLibrary, maxFileSize, getIsInvalidFile, onFileUploadFailed, setSelectedImage }) => {
    const [isCameraCapturedImage, setIsCameraCapturedImage] = React.useState(false);
    const [uploadedFile, setUploadedFile] = React.useState(null);
    const [capturedImage, setCapturedImage] = React.useState('');
    const [uiGuidanceScores, setUIGuidanceScores] = React.useState({
        brightness: 0,
        contrast: 0,
        blur: 0,
        gamma: 0
    });
    const handleSaveFile = () => __awaiter(void 0, void 0, void 0, function* () {
        let dataFile = null;
        if (!isCameraCapturedImage && uploadedFile) {
            dataFile = uploadedFile;
        }
        else if (capturedImage) {
            const currentDate = moment(new Date()).format('YYYYMMDDHHmmssSSS');
            const imageName = `${currentDate}.jpeg`;
            const fileWithGPS = yield addGpsToImage(capturedImage, imageName);
            dataFile = fileWithGPS;
        }
        if (dataFile) {
            onSaveCapturedPhoto({
                file: dataFile,
                isSelected: true,
                fileDescription: sequenceScreenName,
                isCameraCapturedImage
            }, uiGuidanceScores);
        }
        setSelectedImage && setSelectedImage({});
    });
    const handleCameraCapture = (image) => __awaiter(void 0, void 0, void 0, function* () {
        setIsCameraCapturedImage(true);
        setCapturedImage(image);
    });
    React.useEffect(() => {
        if (uploadedFile || capturedImage) {
            handleSaveFile();
        }
    }, [uploadedFile, capturedImage]);
    const handleFileUpload = (file) => {
        const isInvalidFile = getIsInvalidFile({
            maxFileSize,
            allowedFileTypes: PhotoCaptureAllowedMimeTypeConstant,
            file
        });
        if (!isInvalidFile) {
            setIsCameraCapturedImage(false);
            setUploadedFile(file);
        }
        else {
            onFileUploadFailed();
            onViewChange(IntelligentPhotoCaptureViewType.NONE, sequenceScreenName);
        }
    };
    return (React.createElement(IntelligentPBEContainerComponent, { islanguageHide: true, appTheme: appTheme, isFooter: false, hasMultipleButton: false, shouldShowAvatar: false, movePrevious: () => onViewChange(IntelligentPhotoCaptureViewType.NONE, sequenceScreenName) },
        React.createElement(IntelligentGenericWebcamComponent, { isImageAnalysisVisible: true, onCapture: handleCameraCapture, handleFileUpload: handleFileUpload, headerText: getScreenTitleText(questionSubType, sequenceScreenName), shouldFlipCamera: false, setUIGuidanceScores: setUIGuidanceScores, shouldHideDeviceLibrary: (disableLibrary === PhotoCaptureConstants.Y && true) || false })));
};
//# sourceMappingURL=IntelligentPhotoCaptureCameraView.js.map